import { render, staticRenderFns } from "./CurtainTreeAppeal.vue?vue&type=template&id=68bab6b5&scoped=true"
import script from "./CurtainTreeAppeal.vue?vue&type=script&lang=js"
export * from "./CurtainTreeAppeal.vue?vue&type=script&lang=js"
import style0 from "./CurtainTreeAppeal.vue?vue&type=style&index=0&id=68bab6b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bab6b5",
  null
  
)

export default component.exports